import React from 'react'
import RenderProfilePicture from '../../../../_helpers/profile-picture';
import { Row, Col } from 'react-bootstrap'

export default function Participant({ type, conversation }) {
  if (type === 'from') {
    return (
      <Row>
        <Col xs='auto' className='pr-0'>
          <RenderProfilePicture image={conversation.firstMessage.sentBy.profile} circle cached={true} width={35} height={35} />
        </Col>
        <Col>
          {`${conversation.firstMessage.sentBy.firstName} ${conversation.firstMessage.sentBy.lastName}`}<br />
          <span className="text-muted">{'provider' in conversation.firstMessage ? conversation.firstMessage.sentBy.type : 'Patient'}</span>
        </Col>
      </Row>
    )
  }
  else {
    if (conversation.type === 'PATIENT_INITIATED') {
      return (
        <Row>
          <Col xs='auto' className='pr-0'>
            <RenderProfilePicture image={conversation.licensedProfessional.profileUrl} circle cached={true} width={35} height={35} className='m-auto' />
          </Col>
          <Col>
            {`${conversation.licensedProfessional.firstName} ${conversation.licensedProfessional.lastName}`}<br />
            
            { conversation.location &&
              <span className="font-weight-light text-muted">{conversation.location.name}</span>
            }
          </Col>
        </Row>
      )
    } else {
      return (
        <Row>
          <Col xs='auto' className='pr-0'>
            <RenderProfilePicture image={conversation.patient.profile} circle cached={true} width={35} height={35} className='m-auto' />
          </Col>
          <Col>
            {`${conversation.patient.firstName} ${conversation.patient.lastName}`}<br />
            <span className="text-muted">Patient</span>
          </Col>
        </Row>
      )
    }
  }
}
